import { Activity, Component } from '@cms-max/medicare-api-sdk'
import { Button, Close } from '@cmsgov/ds-medicare-gov'
import classNames from 'classnames'
import { AlertBanner } from 'components/AlertBanner'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import './MfaBanner.scss'

type MfaBannerProps = {
  content: string
  messageId: string
  profileId: string
  onClose: () => void
  variant: 'legacy'
}

export const MfaBanner = ({ content, messageId, profileId, onClose, variant }: MfaBannerProps) => {
  const { t } = useTranslation('common')
  // Apply margin bottom for if these stack and also to fit MBP styling when displayed there
  const alertClasses = classNames('ds-u-margin-bottom--2', { 'ch-c-alert-legacy': variant === 'legacy' })

  // Set link click events on all inner rendered anchor tags
  const handleRendererRef = (ref: HTMLDivElement) => {
    ref?.querySelectorAll('a').forEach((anchorElement: HTMLAnchorElement) => {
      anchorElement.onclick = (e) => {
        const { href, innerText } = anchorElement
        window.globalHeaderEvents?.handleEvent({
          core: {
            activity: Activity.LinkClick,
            coreClickData: {
              linkUrl: href,
              linkText: innerText,
              messageId,
              profileId
            },
            property: 'MAX',
            component: Component.MessageCenterContent
          }
        })
      }
    })
  }

  useEffect(() => {
    window.globalHeaderEvents?.handleEvent({
      core: {
        activity: Activity.MessageRender,
        coreClickData: {
          messageId,
          profileId
        },
        property: 'MAX',
        component: Component.MessageCenter
      }
    })
  }, [messageId, profileId])

  return (
    <AlertBanner style={{ position: 'relative' }} className={alertClasses}>
      <div className="ds-u-display--flex ds-u-align-items--start">
        <div ref={handleRendererRef} dangerouslySetInnerHTML={{ __html: content }} className="ds-u-margin--0 ds-text" style={{ alignSelf: 'center' }} />

        <Button
          className="ch-c-alert--close ch-c-button ch-c-button--transparent ds-u-padding--0 ds-u-padding-left--1 ds-u-margin-left--auto"
          onClick={onClose}
          aria-label={t('close')}
        >
          <Close />
        </Button>
      </div>
    </AlertBanner>
  )
}
